<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'account.activity.page.title'" [backButtonLink]="'/'"></fgb-page-header>
<!--Sub Nav-->
<ng-container *notInPopulation="[population.Kids]">
  <div class="container">
    <fgb-account-nav></fgb-account-nav>
  </div>
</ng-container>
<div class="container" [ngClass]="{ 'kids-activity': isKid }">
  <div class="points-history">
    <fgb-transaction-history
      [transactionTypes]="[transactionTypes.loyalty]"
      [accountView]="true"
      [isTransferPage]="false"
    ></fgb-transaction-history>
  </div>
</div>
